import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TenantRouterService } from '../../../services/tenant-router.service';

@Component({
    selector: 'app-end-of-free-trial-dialog-user',
    templateUrl: './end-of-free-trial-dialog-user.component.html',
    imports: [MatDialogModule, MatButtonModule],
})
export class EndOfFreeTrialDialogUserComponent {
    private readonly tenantRouterService = inject(TenantRouterService);
    private readonly dialogRef = inject(MatDialogRef<EndOfFreeTrialDialogUserComponent>);

    signOut(): void {
        this.dialogRef.close();
        this.tenantRouterService.navigate(['sign-out']);
    }
}
